import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable ,  of } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';
import { NewsletterService } from '../../../shared/services/newsletter.service';
import { IPaginationNewsletter, ISubscriber } from './ipagination-newsletter.model';

export class NewslettersDataSource implements DataSource<ISubscriber> {

  private newslettersSubject = new BehaviorSubject<ISubscriber[]>([]);
  private paginationSubject = new BehaviorSubject<IPaginationNewsletter>({} as IPaginationNewsletter);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: NewsletterService) { }

  connect(_collectionViewer: CollectionViewer): Observable<ISubscriber[]> {
    return this.newslettersSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.newslettersSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(sortBy = 'email', sortAsc = true, offset = 0, limit = 5) {
    this.loadingSubject.next(true);
    this.service.find({ offset, limit, sortBy, sortAsc} as DataTableParams).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPaginationNewsletter) => {
      if (data && data.subscribers) {
        this.newslettersSubject.next(data.subscribers);
      } else {
        this.newslettersSubject.next([]);
      }
      this.paginationSubject.next(data);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
